    <template>
    <div class="alarmProfile_main" :class="{'cn':version == '1'}">
        <div class="alarmProfile_top">
            <div class="box btn" @click="linkToFun('/service')">
                <i class="iconfont icon-back"></i><span class="span1">{{$t('App.room_light.text1')}}</span>
            </div>
            <div class="l"></div>
            <div class="box"><span class="span2">{{$t('App.sideBar.text11')}} →</span></div>
            <div class="box">
                <span class="span1">{{$t('App.service.text4')}}</span>
            </div>
        </div>
        <div class="alarmProfile_content">
            <div class="toolbar">
                <div class="toolbar_l">
              <!--       <el-select v-model="userId">
                        <el-option
                            v-for="item in userNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select> -->
                    <el-input :placeholder="$t('App.placeholder.text3')" v-model="keywords" @keyup.native="getRepairListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getRepairList()"></i>
                    </el-input>
                </div>
                <div class="toolbar_r">
                    <div class="btn" @click="addAlarmProfileFun()">
                        <img :src="img_centralizedSetting">
                        <span>{{$t('App.service.text21')}}</span>
                    </div>
                </div>
            </div>
            <div class="table_box">
                <div class="table_top">
                    <div class="main_top">
                        <div class="main_top_l">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                            <div class="btn" @click="postDelRepair(checkList,'batch')">
                                <i class="iconfont icon-delete"></i>
                                <span>{{$t('App.lights.text1')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                    <el-table
                        ref="alarmProfileDataList"
                        v-loading="loading.alarmProfileDataList"
                        element-loading-background="rgba(0, 0, 0, 0.5)"
                        height="100%"
                        :data="alarmProfileDataList">
                        <el-table-column
                            :label="$t('App.lights.text33')"
                            :prop="'index'"
                            align="left"
                            :width="70">
                            <template slot-scope="scope">
                                <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-for="(item) in repairArr"
                            :key="'table_'+item.prop"
                            :prop="item.prop"
                            :label="item.label"
                            :align="item.align?item.align:'center'"
                            :width="item.width"
                            :show-overflow-tooltip="true"
                            :min-width="item.minWidth">
                            </el-table-column>
                            <el-table-column
                            align="center"
                            :width="120"
                            :label="$t('App.lights.text6')">
                            <template slot-scope="scope">
                                <span class="btn" @click="seeFun(scope.row)" :title="$t('App.lights.text35')">
                                    <i class="iconfont icon-chakan"></i>
                                </span>
                                <span class="btn" @click="editInfo(scope.row)" :title="$t('App.lights.text7')">
                                    <i class="iconfont icon-bianji"></i>
                                </span>
                                <span class="btn" @click="postDelRepair(scope.row)" :title="$t('App.lights.text1')">
                                    <i class="iconfont icon-delete"></i>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-checkbox-group>
                <div class="pagination_box">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 设置 -->
        <div class="alarmProfileSetting_wrap scrollbar_style" v-show="alarmProfileSettingTkShowbg">
            <div class="alarmProfileSetting_wrap_bg" @click="alarmProfileSettingTkClose()"></div>
            <div class="alarmProfileSetting_box" :class="{'alarmProfileSetting_tk_show':alarmProfileSettingTkShow}">
                <div class="alarmProfileSetting_title">
                    <span class="span1">{{alarmProfileTkTitle}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text42')}}</span>
                        <el-input v-model="alarmProfileForm.name" placeholder="Please enter name" v-if="alarmProfileTkTitle != $t('App.service.text24')"></el-input>
                        <span  v-if="alarmProfileTkTitle == $t('App.service.text24')">{{alarmProfileForm.name}}</span>
                    </div>
                </div>
                <div class="table">
                    <div class="tr">
                        <div class="th w_1">{{$t('App.service.text25')}}</div>
                        <div class="th w_2">{{$t('App.service.text26')}}</div>
                        <div class="th w_2">{{$t('App.service.text27')}}</div>
                        <div class="th w_2">{{$t('App.service.text28')}}</div>
                        <!-- <div class="th w_2">Channel</div> -->
                        <div class="th w_3"></div>
                    </div>
                    <div class="tr" v-for="(obj,index) in settingFormArr" :key="'setting_'+index">
                        <div class="td w_1">
                            <el-dropdown @command="settingDataTypeCommand" trigger="click" @visible-change="commandHide('dropdown_setting_data_type_'+index)" v-if="alarmProfileTkTitle != $t('App.service.text24')">
                                <span class="span1"><span>{{obj.dataTypeName}}</span><i class="el-icon-caret-bottom el-icon--right"></i></span>
                                <el-dropdown-menu slot="dropdown" :class="'scrollbar_style '+'dropdown_setting_data_type_'+index">
                                    <el-dropdown-item v-for="item in settingDataTypeNav" :command="{'data':obj,'item':item}" :key="'floor'+item.id" :class="{'select':item.id==obj.dataType}">{{item.name}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <span class="text" v-if="alarmProfileTkTitle == $t('App.service.text24')">{{obj.dataTypeName}}</span>
                        </div>
                        <div class="td w_2">
                            <el-dropdown @command="settingConditionCommand" trigger="click" @visible-change="commandHide('dropdown_setting_Condition_'+index)" v-if="alarmProfileTkTitle != $t('App.service.text24') && obj.dataType != 3">
                                <span class="span1"><span>{{obj.sumTypeName}}</span><i class="el-icon-caret-bottom el-icon--right"></i></span>
                                <el-dropdown-menu slot="dropdown" :class="'scrollbar_style '+'dropdown_setting_Condition_'+index">
                                    <el-dropdown-item v-for="item in settingConditionNav" :command="{'data':obj,'item':item}" :key="'floor'+item.id" :class="{'select':item.id==obj.sumType}">{{item.name}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <span class="text" v-if="alarmProfileTkTitle != $t('App.service.text24') && obj.dataType == 3">{{obj.sumTypeName}}</span>
                            <span class="text" v-if="alarmProfileTkTitle == $t('App.service.text24')">{{obj.sumTypeName}}</span>
                        </div>
                        <div class="td w_2">
                            <el-input v-model="obj.parameter" placeholder="" type="Number" v-if="alarmProfileTkTitle != $t('App.service.text24') && obj.dataType != 3"></el-input>
                            <span  v-if="alarmProfileTkTitle != $t('App.service.text24') && obj.dataType == 3">{{$t('App.service.text53')}}</span>
                            <span  v-if="alarmProfileTkTitle == $t('App.service.text24')">{{obj.parameter}}</span>
                        </div>
                        <div class="td w_2">
                            <el-dropdown @command="settingScheduleCommand" trigger="click" @visible-change="commandHide('dropdown_setting_Schedule_'+index)" v-if="alarmProfileTkTitle != $t('App.service.text24')">
                                <span class="span1"><span>{{obj.scheduleName}}</span><i class="el-icon-caret-bottom el-icon--right"></i></span>
                                <el-dropdown-menu slot="dropdown" :class="'scrollbar_style '+'dropdown_setting_Schedule_'+index">
                                    <el-dropdown-item v-for="item in settingScheduleNav" :command="{'data':obj,'item':item}" :key="'floor'+item.id" :class="{'select':item.id==obj.schedule}">{{item.name}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <span  class="text"  v-if="alarmProfileTkTitle == $t('App.service.text24')">{{obj.scheduleName}}</span>
                        </div>
                        <div class="td w_3">
                            <div class="btn_del" v-if="alarmProfileTkTitle != $t('App.service.text24')">
                                <i class="iconfont icon-duankai" @click="settingFormArrDel(index)"></i>
                            </div>
                        </div>
                    </div>
                    <div class="tr" v-if="alarmProfileTkTitle != $t('App.service.text24')">
                        <div class="btn" @click="settingFormArrAdd()">{{$t('App.service.text29')}}</div>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveAlarmProfileSetting()" v-if="alarmProfileTkTitle != $t('App.service.text24')">{{$t('App.room.text35')}}</div>
                    <div class="btn" @click="alarmProfileSettingTkClose()" v-if="alarmProfileTkTitle == $t('App.service.text24')">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">

    import { mapGetters } from 'vuex'
    import allUrl from '../../api/allUrl.js'
    import base from '../../api/base.js'

	export default {
		name:'alarmProfile',
		data () {
			return{
                userId:'',
                userNav:[],
                keywords:'',

                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                repairArr:[],
                alarmProfileDataList:[],
                repairDataIdList:[],
                maintenanceStatusArr:['Maintenance','Repaired','No maintenance'],

                currentPage:1,
                pageSize:20,
                total:0,

                alarmProfileTkTitle:'',
                alarmProfileTkShowbg:false,
                alarmProfileTkShow:false,
                alarmProfileForm:{
                    name:'',
                },
                alarmProfileId:'',

                userPermissionList:[],
                userPermissionList_:[],
                userPermissionListR:[],

                alarmProfileSettingTkShowbg:false,
                alarmProfileSettingTkShow:false,
                settingDataTypeNav:[{id:'0',name:'Set temperature'},{id:'1',name:'Set CO₂'},{id:'2',name:'Set AQI'},{id:'3',name:'Set connectivity'}],
                settingConditionNav:[{id:'0',name:'<'},{id:'1',name:'>'},{id:'2',name:'='}],
                settingScheduleNav:[{id:'0',name:'Everyday'}],
                // settingScheduleNameArr:[],
                settingChannelNav:[],
                // settingChannelNameArr:[],
                settingFormArr:[{
                    dataType:'0',
                    dataTypeName:'Set temperature',
                    sumType:'0',
                    sumTypeName:'<',
                    parameter:'0',
                    schedule:'0',
                    scheduleName:'Everyday',
                }],

				loading:{
				},

                img_centralizedSetting:'',
			}
		},
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',
            }),
        },
		components:{
			// 'sideBar':sideBar
		},
		mounted(){
            this.img_centralizedSetting = require('../../img/centralizedSetting.png');
            if(this.version == '1'){
                this.img_centralizedSetting = require('../../img/centralizedSetting_v1.png');
            }

            this.maintenanceStatusArr = [this.$t('App.service.text16'),this.$t('App.service.text17'),this.$t('App.service.text15')];
            this.settingDataTypeNav = [
                {id:'0',name:this.$t('App.service.text30')},
                {id:'1',name:this.$t('App.service.text31')},
                {id:'2',name:this.$t('App.service.text62')},
                {id:'3',name:this.$t('App.service.text33')},
                {id:'4',name:this.$t('App.service.text63')},
                {id:'5',name:this.$t('App.service.text64')},
                {id:'6',name:this.$t('App.service.text65')}
            ];

            this.settingScheduleNav = [{id:'0',name:this.$t('App.service.text34')}];
            this.settingFormArr = [{
                dataType:'0',
                dataTypeName:this.$t('App.service.text30'),
                sumType:'0',
                sumTypeName:'<',
                parameter:'0',
                schedule:'0',
                scheduleName:this.$t('App.service.text34'),
            }];

            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:false,
            })

            this.repairArr = [
                {prop:'name',label:this.$t('App.room.text42'),minWidth:70},
            ];

            this.getUserNav(()=>{
                if(this.userNav.length > 0){
                    this.userId = this.userNav[0].id;
                    this.getRepairList();
                }
            });
		},
		methods:{
            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
			linkToFun(val){
				this.$router.push({path:val});
				this.$store.commit('ROUTERSTRFUN',{
					routerStr:val,
				})
			},
            /*用户下拉列表*/
            getUserNav(callback){
                base.ajax_post(
                    allUrl.userManagement.userNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        this.userNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            settingDataTypeCommand(obj){
                obj.data.dataType = obj.item.id;
                obj.data.dataTypeName = obj.item.name;
                console.log(obj.item.id)
                if(obj.item.id == 3){
                    obj.data.sumType = '2';
                    obj.data.sumTypeName = '=';

                    obj.data.parameter = '0';
                }
            },
            settingConditionCommand(obj){
                obj.data.sumType = obj.item.id;
                obj.data.sumTypeName = obj.item.name;
            },
            settingScheduleCommand(obj){
                obj.data.schedule = obj.item.id;
                obj.data.scheduleName = obj.item.name;
            },
            settingFormArrAdd(){
                this.$set(this.settingFormArr,this.settingFormArr.length,{
                    dataType:'0',
                    dataTypeName:this.$t('App.service.text30'),
                    sumType:'0',
                    sumTypeName:'<',
                    parameter:'0',
                    schedule:'0',
                    scheduleName:this.$t('App.service.text34'),
                });

            },
            settingFormArrDel(val){
                this.settingFormArr.splice(val,1);
            },
            alarmProfileSettingTkClose(){
                let this_ = this;
                this.alarmProfileSettingTkShow = false;
                setTimeout(function(){
                    this_.alarmProfileSettingTkShowbg = false;
                },400)
            },
            editInfo(obj){
                this.alarmProfileTkTitle = this.$t('App.service.text23');
                this.alarmProfileSettingTkShowbg = true;
                this.$nextTick(function(){
                    this.alarmProfileSettingTkShow = true;
                })
                this.alarmProfileId = obj.id;
                this.alarmProfileForm.name = obj.name;
                base.ajax_post(
                    allUrl.alarmProfile.getInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:this.alarmProfileId,
                    },
                    {},
                    data=>{
                        this.settingFormArr = data.data.conList;
                        for(let d of this.settingFormArr){
                            for(let dd of this.settingDataTypeNav){
                                if(dd.id == d.dataType){
                                    d.dataTypeName = dd.name
                                }
                            }
                            for(let dd of this.settingConditionNav){
                                if(dd.id == d.sumType){
                                    d.sumTypeName = dd.name
                                }
                            }
                            for(let dd of this.settingScheduleNav){
                                if(dd.id == d.schedule){
                                    d.scheduleName = dd.name
                                }
                            }
                        }
                    },
                    this
                )
            },
            postSaveAlarmProfileSetting(){
                let this_ = this;
                base.ajax_post(
                    allUrl.alarmProfile.saveAlarmProfile,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:this.alarmProfileId,
                        conList:this.settingFormArr,
                        ...this.alarmProfileForm,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        this.alarmProfileSettingTkShow = false;
                        setTimeout(function(){
                            this_.alarmProfileSettingTkShowbg = false;
                        },400)
                        this.getRepairList();
                    },
                    this
                )
            },

            seeFun(obj){
                this.alarmProfileTkTitle = this.$t('App.service.text24');
                this.alarmProfileSettingTkShowbg = true;
                this.$nextTick(function(){
                    this.alarmProfileSettingTkShow = true;
                })
                this.alarmProfileId = obj.id;
                this.alarmProfileForm.name = obj.name;
                base.ajax_post(
                    allUrl.alarmProfile.getInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:this.alarmProfileId,
                    },
                    {},
                    data=>{
                        this.settingFormArr = data.data.conList;
                        for(let d of this.settingFormArr){
                            for(let dd of this.settingDataTypeNav){
                                if(dd.id == d.dataType){
                                    d.dataTypeName = dd.name
                                }
                            }
                            for(let dd of this.settingConditionNav){
                                if(dd.id == d.sumType){
                                    d.sumTypeName = dd.name
                                }
                            }
                            for(let dd of this.settingScheduleNav){
                                if(dd.id == d.schedule){
                                    d.scheduleName = dd.name
                                }
                            }
                        }
                    },
                    this
                )
            },
            /*添加编辑设备*/
            addAlarmProfileFun(){
                this.alarmProfileId = '';
                this.alarmProfileForm.name = '';
                this.settingFormArr = [];
                this.alarmProfileTkTitle = this.$t('App.service.text21');
                this.alarmProfileSettingTkShowbg = true;
                this.$nextTick(function(){
                    this.alarmProfileSettingTkShow = true;
                })
            },
            alarmProfileTkClose(){
                let this_ = this;
                this.alarmProfileTkShow = false;
                setTimeout(function(){
                    this_.alarmProfileTkShowbg = false;
                },400)
            },
            /*删除维修人员*/
            postDelRepair(obj,type){
                let alarmProfileId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('App.message.text23'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(alarmProfileId == ''){
                                alarmProfileId = id;
                            }else{
                                alarmProfileId += ','+id;
                            }
                        }
                    }
                }else{
                    alarmProfileId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        this.$t('App.message.text27'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.alarmProfile.delAlarmProfile,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                id:alarmProfileId,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getRepairList();
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            /*设备列表*/
            getRepairListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getRepairList();
                }
            },
            getRepairList(callback){
                base.ajax_post(
                    allUrl.alarmProfile.getList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        page:this.currentPage,
                        count:this.pageSize,
                        keywords:this.keywords,
                        // userId:this.userId,
                    },
                    {},
                    data=>{
                        this.alarmProfileDataList = data.data.list;
                        this.total = Number(data.data.total);

                        this.repairDataIdList = [];
                        this.checkList = [];
                        this.isIndeterminate = false;
                        for(let d of this.alarmProfileDataList){
                            this.repairDataIdList.push(d.id);
                            this.$set(d,'brightness_',d.brightness*2);
                            this.$set(d,'color_',d.color*300+3000);
                            this.$set(d,'brightnessLoading',false);
                            this.$set(d,'colorLoading',false);
                        }

                        let i = 1 + (this.currentPage-1)*this.pageSize;
                        for(let d of this.alarmProfileDataList){
                            d.webIndex = i;
                            i++;
                        }
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getRepairList();
                // console.log(val)
            },
            handleCheckAllChange(val) {
                this.checkList = val ? this.repairDataIdList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.repairDataIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.repairDataIdList.length;
            },
        },
        watch:{
            userId:function(){
                if(this.userId){
                    this.getRepairList();
                }
            },
        }
    }
</script>

<style type="text/css" lang="less">
    .alarmProfile_main{
		width: 100%;
		height: 100%;
		// height: 105rem;
		min-height: 50rem;
		// min-width: 120rem;
		margin: 0 auto;
		overflow: hidden;
		position: relative;
		background: #F6F8FA;
        &.cn{
            .alarmProfile_content{
                .toolbar .toolbar_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .table_box{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .alarmProfileSetting_wrap .alarmProfileSetting_box{
                .table .tr .btn{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .btn_box .btn{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
            }
        }
        .alarmProfile_top{
            display: flex;
            width: 100%;
            align-items: center;
            padding-left: 1rem;
            height: 2.67rem;
            background: #FFFFFF;
            box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05);
            .span1{
                font-size:1rem;
                font-family:AlibabaPuHuiTiR;
                color:rgba(51,51,51,1);
            }
            .span2{
                font-family: AlibabaPuHuiTiR;
                font-size: 1rem;
                color: #A3AFBB;
            }
            .box{
                margin-left: 1rem;
            }
            .btn{
                line-height: 2.67rem;
                cursor: pointer;
                .iconfont{
                    margin-right: 0.5rem;
                    font-size: 0.8rem;
                }
            }
        }
        .alarmProfile_content{
            height: calc(100% - 3rem);
            margin: 1.5rem 0;
            .toolbar{
                padding: 0 1.67rem;
                display: flex;
                justify-content: space-between;
                .toolbar_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        width: 11.42rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 18rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
                .toolbar_r{
                    .btn{
                        margin-left: 1rem;
                        height: 2.5rem;line-height: 2.5rem;
                        padding: 0 1.25rem;
                        background: #FFFFFF;
                        border: 1px solid #F0F0F0;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 0.5rem;
                            height: 1rem;
                        }
                    }
                }
            }
            .table_box{
                height: calc(100% - 5.67rem);
                margin: 0.8rem 1.67rem 0;
                background-color:#fff;
                border: 1px solid rgba(240, 240, 240, 1);
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    height: 3.2rem;line-height: 3.2rem;
                    .main_top_l{
                        margin-left: 1.67rem;
                        display: flex;
                        .btn{
                            margin-left: 1.29rem;
                            display: flex;align-items: center;
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            i{
                                font-size:0.8rem;
                                color: #C6CDD5;
                            }
                            span{
                                margin-left: 0.5rem;
                            }
                        }
                    }
                }
                .el-checkbox-group{
                    height: calc(100% - 10rem);
                }
                .el-table{
                    .btn{
                        padding: 0.5rem;
                        cursor: pointer;
                        &+.btn{
                            margin-left: 0.2rem;
                        }
                        i{
                            color: #A3AFBB;
                            font-size:0.8rem;
                        }
                        &:hover{
                            i{
                                color: #05CFAB;
                            }
                        }
                    }
                    th{
                        font-weight:initial;
                        height: 3rem;
                        border-top: 1px solid #F0F0F0;
                        border-bottom: 1px solid #F0F0F0;
                        padding: 0;
                        background: #F6F8FA;
                        &>.cell{
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                        }
                    }
                    td{
                        padding: 0;
                        height: 3rem;
                        &>.cell,.el-checkbox__label{
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #657085;
                            }
                    }
                    .maintenanceStatus{
                        .text_1{
                            color: #05cfab;
                        }
                        .text_2{
                            color: #FF0C4D;
                        }
                    }
                }
                .pagination_box{
                    margin-top: 2rem;
                    height: 2.5rem;line-height: 2.5rem;
                    .el-pagination{
                        float: right;
                    }
                    .btn-prev .el-icon{
                        font-size:1rem;
                        color: #666666;
                        font-family: PingFang-SC-Medium;
                    }
                    button{
                        width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                        padding: 0;
                        background: rgba(246, 248, 250, 1);
                        border-radius: 0.2rem;
                    }
                    .el-pager li{
                        margin-left: 0.83rem;
                        width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                        padding: 0;
                        background: rgba(246, 248, 250, 1);
                        border-radius: 0.2rem;
                        &:hover{
                        color: #05CFAB;
                        background-color: rgba(62, 175, 55, 0.1);
                        }
                    }
                    .btn-next{
                        margin-left: 0.83rem;
                    }
                    .el-pager li.active{
                        background: #05CFAB;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .alarmProfileSetting_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .alarmProfileSetting_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 30rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .alarmProfileSetting_box{
                position: absolute;
                width: 54rem;height: 100%;
                min-height: 30rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -54rem;
                transition: all 0.5s;
                &.alarmProfileSetting_tk_show{
                    right: 0rem; 
                }
                .alarmProfileSetting_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .table{
                    margin: 2rem 2.5rem 0;
                    .tr{
                        display: flex;
                        margin-bottom: 0.5rem;
                        .th,.td{
                            padding: 0 0.4rem;
                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(51,51,51,1);
                            // flex: 1;
                            &.w_1{
                                width: 32%;
                            }
                            &.w_2{
                                width: 20%;
                            }
                            &.w_3{
                                width: 8%;
                            }
                        }
                        .th{
                            height: 2rem;line-height:2rem;
                        }
                        .td{
                            height: 3rem;line-height:3rem;
                            color: #606266;
                            font-size: 1.2rem;
                            .text{
                                background:rgba(246,248,247,1);
                                display: inline-block;
                                width: 100%;
                                padding: 0 0.4rem;
                                box-sizing: border-box;
                            }
                            .el-dropdown{
                                width: 100%;
                                background:rgba(246,248,247,1);
                                cursor: pointer;
                                color: #606266;
                                font-size: 1.2rem;
                                .el-dropdown-selfdefine{
                                    width: 100%;
                                    box-sizing: border-box;
                                    padding: 0 0.4rem;
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                }
                            }
                            .el-input{
                                .el-input__inner{
                                    border: none;
                                    height: 3rem;line-height:3rem;
                                    background:rgba(246,248,247,1);
                                }
                            }
                            .btn_del{
                                text-align: center;
                                cursor: pointer;
                                .iconfont{
                                    color:#666666;
                                    font-size: 1.2rem;
                                }
                            }
                        }
                        .btn{
                            width:5.83rem;
                            height:2.67rem;line-height:2.67rem;
                            background:rgba(5,207,171,1);
                            border-radius:0.17rem;
                            text-align: center;
                            cursor: pointer;

                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(255,255,255,1);
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }

        }
	}
</style>